import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts a specialization enum value (e.g. FAMILY_MEDICINE or FamilyMedicine)
 * to a human-readable label (e.g. "Family Medicine").
 *
 * Handles both SCREAMING_SNAKE_CASE (from the backend) and PascalCase (frontend enum).
 */
@Pipe({
  name: 'specializationLabel',
  standalone: true,
})
export class SpecializationLabelPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return 'General Practitioner';

    // Handle SCREAMING_SNAKE_CASE: FAMILY_MEDICINE → Family Medicine
    if (value.includes('_')) {
      return value
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
    }

    // Handle PascalCase: FamilyMedicine → Family Medicine
    return value.replace(/([A-Z])/g, ' $1').trim();
  }
}
